import React from 'react';
import dmImage from "../../../assets/images/approvals/dm.png";
import dmccImage from "../../../assets/images/approvals/rta.png";
import difcImage from "../../../assets/images/approvals/approval1.jpg";

import dcdImage from "../../../assets/images/approvals/dcd.png";
import traImage from "../../../assets/images/approvals/trakhees.png";

import { CiCircleChevRight } from "react-icons/ci"; 
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { FaQuoteRight } from "react-icons/fa";
import Metatag from '../../Metatag/Metatag';

const Multicommodities = () => {
  return (
    <div className="container relative">
<Metatag title="Multi-Commodity Approval Services - Streamline Your Approvals | Megavolt Technical Services" description="Efficient multi-commodity approval solutions tailored to your business needs. Megavolt Technical Services ensures smooth regulatory compliance for diverse commodities. Contact us today!" link="approval/municipality-approval"/>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-5 py-8 md:py-16">
        {/* Main Content */}
        <div className="col-span-12 md:col-span-8 p-3">
          <div className="w-[200px] border">
            <img src={dmccImage} alt="Our Story" className="w-full h-full" />
          </div>
          <div className="my-5">
            <h1 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              Roads and Transport Authority (RTA) Approved Contractor
            </h1>
            <p className="pl-3 pt-2">
              We are a trusted RTA Approved Contractor in Dubai, providing end-to-end support for RTA approvals, road works, infrastructure, and traffic-related projects. Our expert team ensures full compliance with Roads and Transport Authority (RTA) regulations, safety standards, and technical requirements—delivering approvals and execution smoothly and on time.
            </p>
            <p className="pl-3 pt-2">
              Looking for fast and reliable RTA approval in Dubai? Contact our Megavolt experts today.
            </p>
          </div>
          <div className="my-5">
            <h1 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              About Our RTA Approval Services
            </h1>
            <p className="pl-3 pt-2">
              RTA approval is mandatory for any project involving roads, pavements, utilities, drainage, or traffic systems in Dubai. As an RTA-certified contractor, we manage the complete approval process—from documentation to final clearance—ensuring your project proceeds without delays or compliance issues.
            </p>
          </div>

          {/* Requirements List */}
          <div className="my-10">
            <h2 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              Why Choose an RTA Approved Contractor?
            </h2>
            <ul className="list-disc ml-10 space-y-2 pt-2">
              <li>Fully compliant with RTA rules and Dubai regulations.</li>
              <li>Faster and smoother RTA approval process.</li>
              <li>Experienced Civil Engineers and safety professionals.</li>
              <li>Approved machinery and traffic management systems.</li>
              <li>Reduced project risk and delays.</li>
              <li>Reliable execution with on-time delivery.</li>
            </ul>
          </div>

          {/* Approval Process */}
          <div className="my-5">
            <h2 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              RTA Approval Process in Dubai – Step by Step
            </h2>
            {[
              "Initial Consultation: We assess your project scope, location, and RTA requirements.",
              "Contractor & Project Registration: Registration of the company, engineers, and project details with RTA.",
              "Document Submission: Submission of drawings, method statements, and technical documents.",
              "Technical Review by RTA: Evaluation of engineering details, safety plans, and compliance.",
              "Site & Safety Assessment: Verification of traffic diversion plans, equipment, and HSE measures.",
              "Final RTA Approval: Issuance of RTA approval allowing legal project execution.",

            ].map((step, index) => (
              <div className="flex" key={index}>
                <div className="mr-5 relative pt-2">
                  <span className="bg-orange text-white flex items-center justify-center w-12 h-12 rounded-full shadow-md">
                    {index + 1}
                  </span>
                </div>
                <p className="flex-1 mb-10 pt-3 ">{step}</p>
              </div>
            ))}
          </div>

          {/* Essential Documents 
          <div className='md:my-10 my-6'>
                        <h2 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              Essential Documents for DMCC Approved Contractors
            </h2>
            <ul className="ml-4 md:ml-10 space-y-2">
              {[
                "Engineering Degree: Proof of formal education in Civil or Structural Engineering.",
                "Experience Certificate: Documented industry experience, verified for credibility.",
                "UAE Society of Engineers Membership: Ensures compliance with all legal standards.",
                "Trade License: Legal documentation for operating within the DMCC jurisdiction.",
                "Project Plans & Blueprints: Detailed drawings for approval and implementation."
              ].map((doc, index) => (
                <li className="flex" key={index}>
                  <CiCircleChevRight className="text-2xl mt-2 text-orange w-6" />
                  <span className="ml-2 mt-2">{doc}</span>
                </li>
              ))}
            </ul>
                        </div>*/}
                    <div className="my-5">
            <h1 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              Trusted RTA Approval Experts in Dubai
            </h1>
            <p className="pl-3 pt-2">
              With strong expertise in RTA systems, Dubai infrastructure standards, and approval workflows, we ensure your approvals are handled professionally and efficiently. Whether it’s a small utility project or a large infrastructure development, we deliver reliable RTA approval solutions in Dubai.
Call our experts at +971 55 481 2897 for fast and compliant approvals.
            </p>
          </div>
        </div>

        {/* Sidebar */}
        <div className="col-span-12 md:col-span-4 p-3">
          <div className="sticky top-16 border border-[#bcbcbc] p-3 rounded-lg bg-[#e8eaed]">
            <p className="uppercase text-center mb-5 text-xl font-bold">Other Authority Approval</p>
            {[dmImage, dmccImage, difcImage].map((img, idx) => (
              <div key={idx} className="border border-orange w-3/5 mx-auto mb-5">
                <img src={img} alt="Approval logo" className="w-full h-full" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className='p-3 md:py-12'>
        <div className="text-center my-2">
          <h1 className=" font-bold text-2xl md:text-3xl text-center uppercase">What Clients Say</h1> 
        </div>
        <p className="text-center text-orange lg:text-2xl text-xl">
          We care about our clients, so we are popular
        </p>
        <div className="md:my-10 my-8">
          <Swiper
            pagination={{ clickable: true }}
            modules={[Pagination]}
            className="mySwiper"
            slidesPerView={1}
            spaceBetween={30}
            breakpoints={{
              640: { slidesPerView: 1, spaceBetween: 20 },
              768: { slidesPerView: 1, spaceBetween: 40 },
              1024: { slidesPerView: 1, spaceBetween: 50 }
            }}
          >
            {[...Array(3)].map((_, index) => (
              <SwiperSlide className='md:p-12 p-4' key={index}>
                <div className='mb-[40px] shadow-[0_5px_20px_#01010145] p-5 rounded-xl'>
                  <div className='text-center shadow-[0_1rem_3rem_rgba(0, 0, 0, .18)]'>
                    <div className='flex items-center justify-center'>
                      <FaQuoteRight className='text-orange text-[40px] mb-5' />
                    </div>
                    <p className='text-center md:text-lg text-base'>
                      Team did an amazing job for us. On a very short time plan they developed a great presentation out of a word report. Communication was fast, uncomplicated and wished changes were done within hours. I can highly recommend them.
                    </p>
                    <h1 className='text-center font-bold mt-3'>John Hanks, Entrepreneur</h1>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Multicommodities;
